import {useAtomValue} from 'jotai';

import {useAdfoxStore} from '@shared/Ads/Yandex/store';

import {adFoxHasAds} from './atoms';
import {ScriptLoader, StatsSink} from './ControllerParts';

export const AdFoxController = () => {
  const isContextAds = useAdfoxStore().adFoxState.adFoxHasAds;
  const hasAds = useAtomValue(adFoxHasAds) || isContextAds;

  if (!hasAds) {
    return null;
  }
  return (
    <>
      <ScriptLoader />
      <StatsSink />
    </>
  );
};
